module.exports = __webpack_public_path__ + "img/Artboard – 3 (2).ad777ec4.png";